/**
 * @module app.cm
 */

import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { IAssessmentsConfig, ITasksConfig } from 'app/core/models/essette-interfaces';
import { bindable } from 'aurelia-typed-observable-plugin';
import { IAssessmentAttachmentOptions } from 'app/core/components/assessments/assessment-attachment';
import { ICollapse } from 'app/shared/attributes/ess-collapse-attributes';

@autoinject()
export class AssessmentSummary extends ComponentBase {

    ////****************** Fields and Properties ************************************////

    @bindable.objectNull
    public config: IAssessmentsConfig | null = null;
    @bindable.objectNull
    public taskConfig: ITasksConfig | null = null;

    @bindable.boolean
    protected showHistory: boolean = false;

    @bindable.boolean
    protected allExpanded: boolean = false;

    @bindable
    protected case: any = {};

    protected options: IAssessmentAttachmentOptions = {
        showActions: false,
        showBack: false,
        showHeader: false,
        showToc: false,
        showMember: false,
        showMemberSummaryLink: false,
        showTarget: false,
        showTargetSummaryLink: false,
        forceRequiredQuestions: false,
        canReopen: true,
        stickyActions: false,
        isTaskDisabled: false
    }

    ////****************** Element References ***************************************////

    protected $collapse!: ICollapse;
    protected $listElement!: HTMLElement;

    ////****************** Lifecycle events (in order of execution) *****************////

    constructor(...rest: any[]) {
        super(...rest);
    }

    protected bind(): void {
        if(!this.config) { this.logger.warn('Assessment config was not bound'); }
    }

    ////****************** Events ***************************************************////

    protected allExpandedChanged(): void {
        if(this.allExpanded) {
            this.expandAll();
        } else {
            this.collapseAll();
        }
    }

    ////****************** Functions ************************************************////

    protected collapseAll(): void {
        this.$collapse.closeAll();
    }

    protected expandAll(): void {
        // ensure all attachments get loaded
        for(const a of this.case.assessments) {
            if(!a.attachment._state) {
                a.attachment._state = {};
            }
            a.attachment._state.isLoaded = true;
        }

        this.$collapse.openAll();
    }

}
